import { render, staticRenderFns } from "./msg.vue?vue&type=template&id=5664c740&scoped=true&"
import script from "./msg.vue?vue&type=script&lang=js&"
export * from "./msg.vue?vue&type=script&lang=js&"
import style0 from "./msg.vue?vue&type=style&index=0&id=5664c740&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5664c740",
  null
  
)

export default component.exports